import { Locale } from 'shared/i18n/interface'
import { AbstractService } from 'shared/services/AbstractService'
import config from 'config'
import getLogger from 'shared/logger'

export interface RatingsReviewsResponse {
  reviewsCount: number
  ratedXOutOfYLabel: string
  averageRating: number
  reviewsCountLabel: string
  reviewedByNCustomersLabel: string
  stars: number[]
}

export class RatingsAndReviewsApi extends AbstractService {
  public async getRatingsAndReviews(locale: Locale, mpvId: string): Promise<RatingsReviewsResponse> {
    const url = `v1/reviews-summary/${config.tenant}/${locale}/${mpvId}`

    const { data } = await this.api.get<RatingsReviewsResponse>(url)

    return data
  }
}

export const RatingsAndReviewsService = new RatingsAndReviewsApi(config.services.ratingsAndReviewsService, getLogger)
